import { makeStyles } from 'tss-react/mui';
import { ResizablePanelStyleParams } from './resizablePanel.types';

export const useResizablePanelStyles = makeStyles<ResizablePanelStyleParams>()(
  (theme, { separatorOffset }) => {
    const toggleDuration = theme.transitions.duration.shorter;

    return {
      separator: {
        transform: `translateX(${separatorOffset})`,
        '& + [data-panel]': {
          transition: `flex-grow ${toggleDuration}ms ${theme.transitions.easing.easeInOut}, visibility 0s`,
        },
        '&[data-separator="active"] + [data-panel], &[data-separator="focus"] + [data-panel]': {
          transition: 'none',
        },
        '@media (prefers-reduced-motion: reduce)': {
          '& + [data-panel]': { transition: 'none' },
        },
      },
      separatorClosed: {
        '& + [data-panel]': {
          flexGrow: '0 !important',
          visibility: 'hidden',
          transitionDelay: `0s, ${toggleDuration}ms`,
        },
      },
    };
  },
);
